// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    EnrollmentInsVerRequestModel,
    EnrollmentRequestModel,
    EnrollmentResultModelResponse,
    EnrollmentVerifySurveyEntryRequestModel,
    EnrollmentVerifySurveyEntryResultModelResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EnrollmentExtV2Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary 
     * @param programId 
     * @param enrollmentRequestModel 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async basicEnrollmentCreate (programId: number, enrollmentRequestModel: EnrollmentRequestModel, xProgramId?: number): Promise<AxiosResponse<EnrollmentResultModelResponse>> {
        const _url_ = '/enrollment_ext/v2/BasicEnrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling basicEnrollmentCreate.');
        }

        // verify required parameter 'enrollmentRequestModel' is not null or undefined
        if (enrollmentRequestModel === null || enrollmentRequestModel === undefined) {
            throw new Error('Required parameter enrollmentRequestModel was null or undefined when calling basicEnrollmentCreate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentRequestModel, "EnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary 
     * @param programId 
     * @param enrollmentInsVerRequestModel 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollmentCreate (programId: number, enrollmentInsVerRequestModel: EnrollmentInsVerRequestModel, xProgramId?: number): Promise<AxiosResponse<EnrollmentResultModelResponse>> {
        const _url_ = '/enrollment_ext/v2/Enrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentCreate.');
        }

        // verify required parameter 'enrollmentInsVerRequestModel' is not null or undefined
        if (enrollmentInsVerRequestModel === null || enrollmentInsVerRequestModel === undefined) {
            throw new Error('Required parameter enrollmentInsVerRequestModel was null or undefined when calling enrollmentCreate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentInsVerRequestModel, "EnrollmentInsVerRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary 
     * @param programId 
     * @param enrollmentVerifySurveyEntryRequestModel 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async verifySurveyAnswerCreate (programId: number, enrollmentVerifySurveyEntryRequestModel: EnrollmentVerifySurveyEntryRequestModel, xProgramId?: number): Promise<AxiosResponse<EnrollmentVerifySurveyEntryResultModelResponse>> {
        const _url_ = '/enrollment_ext/v2/VerifySurveyAnswer/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling verifySurveyAnswerCreate.');
        }

        // verify required parameter 'enrollmentVerifySurveyEntryRequestModel' is not null or undefined
        if (enrollmentVerifySurveyEntryRequestModel === null || enrollmentVerifySurveyEntryRequestModel === undefined) {
            throw new Error('Required parameter enrollmentVerifySurveyEntryRequestModel was null or undefined when calling verifySurveyAnswerCreate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentVerifySurveyEntryRequestModel, "EnrollmentVerifySurveyEntryRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentVerifySurveyEntryResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentVerifySurveyEntryResultModelResponse");
        }
        return response;
    }
}
